import { createContext } from "react";

export interface AtsIntegration {
  customer_id: string;
  icims_username: string;
  icims_password: string;
  icims_webhook_username: string;
  icims_webhook_password: string;
  customer_group_id: string;
  report_url_type: string;
}

export interface IcimsIntegrationContextType {
  atsIntegrationData: AtsIntegration;
  setAtsIntegration: (atsIntegrationData: AtsIntegration) => void;
}

export const IcimsIntegrationContext =
  createContext<IcimsIntegrationContextType>({
    atsIntegrationData: {
      customer_id: "",
      icims_username: "",
      icims_password: "",
      icims_webhook_username: "",
      icims_webhook_password: "",
      customer_group_id: "",
      report_url_type: "DIRECT_PDF_URL",
    },
    setAtsIntegration: (newState: AtsIntegration) => newState,
  });
